// 账户管理接口
import $http from '@/resource';

const $api = {};

/**
 * 获取添加人下拉备选项
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /users
 */
$api.getUserList = async () => {
    let url = `/users`;
    return await $http.get(url);
  };
  
  /**
   * 企业账户管理列表数据获取
   *
   * @method GET
   *
   * @param {Object} formData 搜索条件
   * 
   * @returns {Promise<*>}
   *
   * @url /account
   */
  $api.getAccountList = async (formData) => {
    let url = `/account`;
    return await $http.get(url,{params:formData});
  };
  
  /**
   * 企业账户的禁止/解除
   *
   * @method PATCH
   *
   * @returns {Promise<*>}
   *
   * @url /account/{id}
   */
  $api.changeAccountStatus = async (id,status) => {
    let url = `/account/${id}`;
    return await $http.patch(url,status);
  };
  
  /**
   * 企业账户信息获取
   *
   * @method GET
   *
   * @param {String} id 企业id
   * 
   * @returns {Promise<*>}
   *
   * @url /account/{id}/detail
   */
  $api.getAccountInfo = async (id) => {
    let url = `/account/${id}/detail`;
    return await $http.get(url);
  };
  
  /**
   * 企业账户信息保存
   *
   * @method PATCH
   *
   * @param {String} id 企业id
   * 
   * @returns {Promise<*>}
   *
   * @url /account/{id}/add
   */
  $api.changeAccountPassword = async (id,password) => {
    let url = `/account/${id}/add`;
    return await $http.patch(url,password);
  };
  
  /**
   * 企业账户详情页绑定手机号列表
   *
   * @method GET
   *
   * @param {String} id 企业id
   * 
   * @param {Object} formData 搜索条件
   * 
   * @returns {Promise<*>}
   *
   * @url /account/{id}/phone
   */
  $api.getAccountPhone = async (id,formData) => {
    let url = `/account/${id}/phone`;
    return await $http.get(url,{params:formData});
  };
  
  /**
   * 企业账户手机号禁止/解除
   *
   * @method PATCH
   *
   * @param {String} id 企业id
   * 
   * @returns {Promise<*>}
   *
   * @url /account/{id}
   */
  $api.changePhoneStatus = async (id,status) => {
    let url = `/account/${id}/phone`;
    return await $http.patch(url,status);
  };
  
  /**
   * 企业账户添加绑定手机号
   *
   * @method POST
   *
   * @param {String} id 企业id
   * 
   * @returns {Promise<*>}
   *
   * @url  /account/{id}/phone
   */
  $api.bandPhone = async (id,data) => {
      let url = `/account/${id}/phone`;
      let res = await $http.post(url,data);
      return res;
  }

export default $api;


// WEBPACK FOOTER //
// ./src/service/enterprise/account.js